module.exports = __webpack_public_path__ + "img/Icon ionic-ios-arrow-up-black-small.0744c5af.svg";